import { render, staticRenderFns } from "./FranceInnovationRenaissanceJP.vue?vue&type=template&id=2a2ca858"
import script from "./FranceInnovationRenaissanceJP.vue?vue&type=script&lang=js"
export * from "./FranceInnovationRenaissanceJP.vue?vue&type=script&lang=js"
import style0 from "./FranceInnovationRenaissanceJP.vue?vue&type=style&index=0&id=2a2ca858&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports